import Vue from 'vue'
import {
  Form,
  FormItem,
  Button,
  Select,
  Option,
  Input,
  Checkbox,
  CheckboxGroup,
  Pagination,
  Loading,
  Tabs,
  TabPane,
  Upload
} from 'element-ui'

Vue.use(Form)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Pagination)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Upload)
Vue.use(Loading.directive)
